export default __webpack_public_path__ + "static/lozenge-icon-dont-light-19af7d69e0aaa27ddda2e7e98dad2e44.png";